var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { attrs: { height: 200, preserveAspectRatio: "none" } },
    [
      _c("rect", {
        attrs: {
          x: "280",
          y: "27",
          rx: "4",
          ry: "4",
          width: "120",
          height: "18"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "280",
          y: "57",
          rx: "4",
          ry: "4",
          width: "100",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "280",
          y: "77",
          rx: "4",
          ry: "4",
          width: "100",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "280",
          y: "97",
          rx: "4",
          ry: "4",
          width: "80",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "280",
          y: "117",
          rx: "4",
          ry: "4",
          width: "80",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "280",
          y: "137",
          rx: "4",
          ry: "4",
          width: "80",
          height: "10"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4142129e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4142129e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/campaigns/CampaignLoadingSkeleton.vue
// module id = null
// module chunks = 